globalThis.Router = class Router {
  constructor(pages) {
    globalThis.ROUTER = this;
    this.abort = new AbortController();
    this.pages = pages;
    this.current = null;
    addEventListener("popstate", this.update.bind(this), this.abort);
    this.update();
  }

  goto(path) {
    history.pushState({}, "Platfo", path);
    this.update();
  }

  remove() {
    this.abort.abort();
    this.current.remove();
    delete globalThis.ROUTER;
  }

  update() {
    this.current?.remove();
    scrollTo(0, 0);
    for (const [pattern, Page] of Object.entries(this.pages)) {
      const match = this.matches(pattern);
      if (!match) continue;
      this.current = new Page(...match);
      return;
    }
    this.current = new NotFound();
    dispatchEvent(new Event("route"));
  }

  matches(pattern) {
    const re = new RegExp(pattern);
    return re.exec(decodeURI(location.pathname));
  }
};
